
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';

import FAQ from './FAQ';
import UsePageTracking from '../components/usePageTracking';


function Punetopanchganicabfare() {



    const cardData =
    {
        keyword: 'Pune to Panchgani Cab   ',
        heading: 'Morya Cabs:  Pune to Panchgani Cab ',
        headingDescription: 'Looking for a reliable and comfortable cab service from Pune to Panchgani? Morya Cabs offers you an affordable and hassle-free way to travel to this scenic hill station. Whether you are planning a family vacation, a weekend getaway, or a peaceful retreat, our fleet of well-maintained vehicles and experienced drivers ensure a smooth journey. We pride ourselves on our punctuality, so you can relax and enjoy the ride without worrying about delays. Choose Morya Cabs for an enjoyable and stress-free journey, and experience the beautiful landscapes of Panchgani at your own pace.',

        top: 'Top Places to Visit in Panchgani',

     "topPlaces": [
    {
        "title": "Table Land",
        "description": "Table Land is one of the most famous landmarks in Panchgani, known for its expansive plateau and breathtaking views. At 4,500 feet above sea level, it offers panoramic views of the surrounding valleys and hills. The spot is ideal for nature walks, photography, or simply relaxing with a picnic. Visitors can also engage in paragliding here, making it an adventurous destination for thrill-seekers."
    },
    {
        "title": "Parsi Point",
        "description": "Parsi Point offers one of the best viewpoints in Panchgani, providing visitors with scenic vistas of the valley and distant hills. It's a popular spot for sightseeing, photography, and enjoying the cool breeze. The lush green hills and serene atmosphere make it a perfect stop for nature lovers."
    },
    {
        "title": "Sydney Point",
        "description": "Sydney Point is another popular viewpoint located on the slopes of the mountain. It offers stunning views of the Krishna Valley, Dhom Dam, and the surrounding hills. It is an ideal place for those looking to experience the natural beauty of Panchgani, perfect for a peaceful retreat or a photography session."
    },
    {
        "title": "Rajpuri Caves",
        "description": "Rajpuri Caves are historically significant and are believed to have been a place of meditation for the sages in ancient times. These caves have religious importance, and a temple dedicated to Lord Karthikeya is located here. The caves, surrounded by lush greenery and a quiet environment, make for a spiritual and serene visit."
    },
    {
        "title": "Mapro Garden",
        "description": "A visit to Mapro Garden is a must for anyone visiting Panchgani. Known for its fresh strawberries, Mapro Garden is famous for its jams, juices, and other strawberry-based products. Enjoy the beauty of the garden while tasting some of the delicious treats or relax in the garden's cozy setting. It’s a perfect place to unwind while enjoying some local delicacies."
    },
    {
        "title": "Kamalgad Fort",
        "description": "For history buffs and adventure enthusiasts, Kamalgad Fort offers an exciting journey through the hills. The fort, located at a high altitude, provides a stunning view of the surrounding area and is an excellent spot for trekking and exploration. It’s a great place to learn about the history of the region while experiencing the beauty of nature."
    },
    {
        "title": "Mahabaleshwar Hill Station",
        "description": "Located just a short drive from Panchgani, Mahabaleshwar is a popular hill station known for its cool climate, lush greenery, and breathtaking views. The area is famous for its viewpoints, lakes, and temples, making it an excellent destination for sightseeing and relaxation."
    },
    {
        "title": "Wai",
        "description": "Wai, a small town near Panchgani, is known for its temples and beautiful surroundings. It offers a peaceful escape from the busy tourist destinations. The town is dotted with temples dedicated to Hindu deities and is a serene place to visit for spiritual seekers and nature lovers alike."
    },
    {
        "title": "Devil's Kitchen",
        "description": "Devil's Kitchen is a fascinating site located in the hills near Panchgani. The name originates from local legends that the Pandavas, characters from the Mahabharata, used these caves during their exile. The caves are surrounded by dense vegetation and offer an interesting spot for explorers and history enthusiasts."
    },
    {
        "title": "Dhobi Waterfall",
        "description": "Dhobi Waterfall, located in the lush forests near Panchgani, is a beautiful and serene spot for nature lovers. The waterfall is surrounded by greenery, and the sound of the water flowing makes it a perfect place to relax and enjoy the beauty of nature. It’s an ideal destination for a peaceful retreat away from the hustle and bustle of city life."
    }
],



"services": [
    {
      "name": "Pune to Panchgani Cab Fare",
      "description": "If you're planning a trip from Pune to Panchgani, Morya Cab offers competitive Pune to Panchgani Cab Fare rates, ensuring an affordable and comfortable travel experience. Our services cater to individuals, families, and groups, with well-maintained vehicles and experienced drivers to take you to your destination safely."
    },
    {
      "name": "Pune to Panchgani Taxi Rates",
      "description": "Morya Cab provides transparent Pune to Panchgani Taxi Rates, offering clear pricing with no hidden charges. Whether you're looking for a one-way ride or a round-trip journey, we offer reasonable taxi rates to fit your budget."
    },
    {
      "name": "Pune to Panchgani Cab Charges",
      "description": "The Pune to Panchgani Cab Charges depend on factors like the type of vehicle and the number of passengers. Morya Cab ensures that our rates are fair and cost-effective for all our customers. We offer a range of vehicles, from sedans to SUVs, to cater to your travel needs."
    },
    {
      "name": "Pune to Panchgani Taxi Fare to Parsi Point",
      "description": "Visiting Parsi Point during your trip to Panchgani? Morya Cab provides an affordable Pune to Panchgani Taxi Fare to Parsi Point. Our taxis will get you to the point comfortably, so you can enjoy the beautiful views of the surrounding area."
    },
    {
      "name": "Pune to Panchgani Cab Pricing",
      "description": "For those looking for clarity in Pune to Panchgani Cab Pricing, Morya Cab offers upfront rates. We strive to provide high-quality service at competitive prices, ensuring that your trip is hassle-free."
    },
    {
      "name": "Pune to Panchgani Taxi Fare Katas Point",
      "description": "If you're heading to Katas Point, Morya Cab offers affordable Pune to Panchgani Taxi Fare Katas Point. The distance is comfortable, and our drivers ensure you enjoy the scenic beauty during the ride."
    },
    {
      "name": "Pune to Panchgani Cab to Sydney Point",
      "description": "Morya Cab offers an efficient and budget-friendly Pune to Panchgani Cab to Sydney Point service. This popular sightseeing location is best enjoyed with a comfortable ride, and we ensure that your journey to Sydney Point is smooth."
    },
    {
      "name": "Pune to Panchgani Taxi Fare List",
      "description": "We provide a detailed Pune to Panchgani Taxi Fare List based on various routes and vehicle types. This transparency helps you choose the best option for your trip while keeping the budget in check."
    },
    {
      "name": "Pune to Panchgani Cab Cost",
      "description": "The Pune to Panchgani Cab Cost varies depending on the type of vehicle you choose and whether you're opting for a one-way or round trip. However, we offer highly competitive prices that ensure great value for your money."
    },
    {
      "name": "Pune to Panchgani Taxi Fare",
      "description": "Our Pune to Panchgani Taxi Fare is designed to be affordable and competitive. You can enjoy your trip without worrying about hidden costs, as Morya Cab ensures a transparent pricing system."
    },
    {
      "name": "Pune to Panchgani Cab",
      "description": "For a comfortable ride, choose Pune to Panchgani Cab services with Morya Cab. We offer reliable cabs, along with professional drivers, to make your trip smooth and enjoyable."
    },
    {
      "name": "Pune Airport to Panchgani Taxi Fare",
      "description": "If you're arriving at Pune Airport and need a ride to Panchgani, we offer the most affordable Pune Airport to Panchgani Taxi Fare. Our drivers will pick you up from the airport and take you directly to your destination."
    },
    {
      "name": "Pune to Panchgani Distance by Taxi Fare",
      "description": "The Pune to Panchgani Distance by Taxi Fare is calculated based on the mileage and time taken. Our rates are designed to be fair, ensuring you enjoy a safe and comfortable journey."
    },
    {
      "name": "Pune to Panchgani Taxi Fare",
      "description": "We offer affordable Pune to Panchgani Taxi Fare options for a hassle-free trip. Whether you're looking for a quick getaway or a relaxed journey, Morya Cab ensures that you get the best fare for your travel."
    },
    {
      "name": "Pune to Panchgani Cab Fare",
      "description": "Enjoy a smooth and comfortable ride with Morya Cab, offering competitive Pune to Panchgani Cab Fare rates. We provide reliable and timely service for all customers."
    },
    {
      "name": "Pune to Panchgani Distance by Taxi Fare",
      "description": "Our Pune to Panchgani Distance by Taxi Fare takes into account the distance, type of vehicle, and other factors, so you can travel at ease without unexpected charges."
    },
    {
      "name": "Pune to Panchgani Ertiga Cab",
      "description": "For a more spacious option, book the Pune to Panchgani Ertiga Cab. Ideal for families or larger groups, the Ertiga offers extra comfort during your journey to Panchgani."
    },
    {
      "name": "Pune to Panchgani Taxi",
      "description": "Looking for a reliable Pune to Panchgani Taxi service? Morya Cab offers safe and timely travel to Panchgani with experienced drivers who are familiar with the best routes."
    },
    {
      "name": "Pune to Panchgani Taxi Distance",
      "description": "Our Pune to Panchgani Taxi Distance services provide you with a comfortable and efficient journey, ensuring you reach your destination without any hassle."
    },
    {
      "name": "Pune to Panchgani Taxi Fare",
      "description": "Morya Cab offers budget-friendly Pune to Panchgani Taxi Fare, ensuring that your trip is affordable without compromising on the quality of the service."
    },
    {
      "name": "Pune to Panchgani Drop Taxi",
      "description": "If you're looking for a Pune to Panchgani Drop Taxi, Morya Cab provides seamless one-way rides to your destination. Enjoy a stress-free trip with our reliable and comfortable taxis."
    },
    {
      "name": "Contact Information for Pune to Panchgani Cab Services",
      "description": "For more information on Pune to Panchgani Cab Fare, Taxi Booking, or to reserve your cab, contact Morya Cab at +91 9371304510. Book your ride today and enjoy a comfortable journey to Panchgani!"
    }
  ],



  tableData: [
    ["Pune to Panchgani Cab Fare", "-Pune to Panchgani Taxi Rates"],
    ["Pune to Panchgani Cab Charges", "-Pune to Panchgani Taxi Fare to Parsi point"],
    ["Pune to Panchgani Cab Pricing", "-Pune to Panchgani Taxi Fare Katas Point"],
    ["Pune to Panchgani Cab to Sydney point", "-Pune to Panchgani Taxi Fare List"],
    ["Pune to Panchgani Cab Cost", "-Pune to Panchgani Cab fare"],
    ["Pune Airport to Panchgani Taxi fare", "-Pune to Panchgani distance by taxi fare"],
    ["Pune to Panchgani Taxi Fare", "-Pune to Panchgani Cab"],
    ["Pune Airport to Panchgani Taxi fare", "-Pune to Panchgani Cab fare"],
    ["Pune to Panchgani distance by taxi fare", "-Pune to Panchgani Ertiga Cab"],
    ["Pune to Panchgani Taxi", "-Pune to Panchgani Taxi Distance"]
],

whychoose: [
    {
        "WhyChooseheading": "Reliable and On-Time Service",
        "WhyChoosedescription": "Morya Cab ensures you have a timely and reliable pickup for your Pune to Panchgani trip. Whether you’re going for a weekend getaway or a peaceful retreat, our drivers will ensure your journey starts and ends on time."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "We provide a range of well-maintained vehicles like sedans, SUVs, and premium cars for your trip from Pune to Panchgani. Our cars are equipped with comfortable seating, air conditioning, and spacious interiors, making your ride relaxing and pleasant."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are well-trained and experienced in handling trips to Panchgani. They know the best routes and prioritize your safety, providing a smooth, enjoyable, and hassle-free journey."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Morya Cab offers competitive pricing for your Pune to Panchgani trip. We believe in full transparency, and there are no hidden charges. You will receive a clear breakdown of the fare before your journey."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our priority. Our vehicles are equipped with the latest safety features like airbags, seat belts, and GPS tracking, ensuring that your trip to Panchgani is secure and comfortable."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Morya Cab operates round the clock, ensuring that you can book your trip to Panchgani at any time that suits your schedule. Our customer service team is available 24/7 for any assistance."
    },
    {
        "WhyChooseheading": "Hassle-Free Booking Process",
        "WhyChoosedescription": "Booking your Pune to Panchgani cab is easy and convenient! You can book through our website, mobile app, or by contacting our customer service team, who will assist you with any questions."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "We understand that every trip is unique. Whether you’re visiting Panchgani for a relaxing holiday or sightseeing, we offer customized travel packages tailored to your preferences to make your trip even more special."
    }
]

        
















    }

    const faqData = [
        {
          question: "How can I book a Pune to Panchgani cab with Morya Cab?",
          answer: "Booking a ride is simple! You can book your cab through our website, mobile app, or by calling our customer service team for personalized assistance."
        },
        {
          question: "Are the drivers experienced for long-distance travel?",
          answer: "Yes, our drivers are highly skilled in long-distance travel and are familiar with the best routes to Panchgani, ensuring a smooth and comfortable journey."
        },
        {
          question: "What types of vehicles are available for Pune to Panchgani travel?",
          answer: "We offer a variety of vehicles including sedans, SUVs, and premium cars, all designed for comfort on your journey to Panchgani."
        },
        {
          question: "How do I pay for my Pune to Panchgani cab rental?",
          answer: "We offer multiple payment options, including cash, credit/debit cards, and online payments through our app, making payment convenient and secure."
        },
        {
          question: "Can I book a round trip for Pune to Panchgani?",
          answer: "Yes, you can book a round trip! Simply provide us with your return details, and we’ll handle everything for you."
        },
        {
          question: "Are there any extra charges for waiting or detours?",
          answer: "If there are any additional charges for waiting time or detours, we will clearly communicate them to you during the booking process, ensuring full transparency."
        },
        {
          question: "Can I hire a taxi for sightseeing in Panchgani?",
          answer: "Yes, we offer sightseeing services in Panchgani. Explore popular spots like Table Land, Sydney Point, and the famous Mapro Garden, with our experienced drivers."
        },
        {
          question: "What is the luggage allowance for a Pune to Panchgani taxi?",
          answer: "Our vehicles can comfortably accommodate standard luggage. If you have more luggage or special requirements, please inform us during the booking process, and we’ll ensure your needs are met."
        },
        {
          question: "Is Morya Cab available for corporate travel between Pune and Panchgani?",
          answer: "Yes, we provide corporate travel services for group trips or business-related visits between Pune and Panchgani, ensuring your journey is comfortable and efficient."
        },
        {
          question: "Why should I choose Morya Cab for my Pune to Panchgani trip?",
          answer: "Morya Cab guarantees a reliable, comfortable, and affordable journey with professional drivers, well-maintained vehicles, and exceptional customer service, making it the best choice for your trip to Panchgani."
        }
      ];
      
      const testimonialData = [
        {
          id: 1,
          name: 'Mr. Shubham Desai',
          role: 'Traveler',
          review: "We had an amazing experience with Morya Cab for our trip to Panchgani. The vehicle was spacious, the driver was courteous, and we felt safe throughout the journey. Highly recommended!",
          rating: 5,
          quoteIcon: '/img/icon/testi-quote.svg',
        },
        {
          id: 2,
          name: 'Mrs. Priya Nair',
          role: 'Family Traveler',
          review: "Morya Cab made our family trip to Panchgani so much more enjoyable. The car was well-maintained, and the driver was knowledgeable about the best routes and local spots. We will definitely use Morya Cab for our future trips!",
          rating: 5,
          quoteIcon: '/img/icon/testi-quote.svg',
        }
      ];
      
      
      
      
      
      
      
      
            
            
            
      











    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9371304510",
            "+91 8379975860",



        ],
        email: "booking@moryacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Shirdi Taxi",
            link: "/Pune-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Bhimashankar Taxi",
            link: "/Pune-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai Taxi",
            link: "/Pune-to-Mumbai-Taxi"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala Taxi",
            link: "/Pune-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mahabaleshwar Taxi",
            link: "/Pune-to-Mahabaleshwar-Taxi"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Aurangabad Taxi",
            link: "/Pune-to-Aurangabad-Taxi"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Nashik-Trimbakeshwar Taxi",
            link: "/Pune-to-Nashik-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Car Rental Services",
            link: "/Pune-Car-Rental-Services"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Ashtavinayak Taxi",
            link: "/Pune-to-Ashtavinayak-Taxi"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Goa Taxi",
            link: "/Pune-to-Goa-Taxi"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Solapur Taxi",
            link: "/Pune-to-Solapur-Taxi"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Hyderabad Cab",
            link: "/Pune-to-Hyderabad-Cab"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Kolhapur Taxi",
            link: "/Pune-to-Kolhapur-Taxi"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Bangalore Taxi",
            link: "/Pune-to-Bangalore-Taxi"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Indore Taxi",
            link: "/Pune-to-Indore-Taxi"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai to Shirdi Taxi",
            link: "/Mumbai-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Borivali to Pune Taxi Service",
            link: "/Borivali-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Vasai to Pune Taxi Service",
            link: "/Vasai-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Dombivli to Pune Taxi Services",
            link: "/Dombivli-to-Pune-Taxi-Services"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Dadar to Shirdi Taxi Service",
            link: "/Dadar-to-Shirdi-Taxi-Service"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Trimbakeshwar Taxi",
            link: "/Mumbai-to-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Bhimashankar Taxi",
            link: "/Mumbai-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai Central to Pune Taxi",
            link: "/Mumbai-Central-to-Pune-Taxi"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Thane to Pune Taxi Service",
            link: "/Thane-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Nashik Taxi",
            link: "/Mumbai-to-Nashik-Taxi"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Lonavala Taxi",
            link: "/Mumbai-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Mumbai Airport to Pune Taxi",
            link: "/Mumbai-Airport-to-Pune-Taxi"
        }
    ];


    const images = [
        { src: "/images/our-fleet/3.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/4.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/5.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/7.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/8.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/10.jpg", alt: "Image 1" },
       
    ];


   
    const jsonLD = {
        "@context": "https://schema.org",
        "@type": "TaxiService",
        "name": "Pune to Panchgani Cab Fare",
        "description": "Get the best and affordable taxi fare for your journey from Pune to Panchgani. We provide taxi services to popular spots like Parsi Point, Katas Point, Sydney Point, and more. Enjoy a comfortable ride at competitive prices.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Office No. 5, First Floor, Sunshine Complex, Near ABC Chowk, Pune",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411014",
          "addressCountry": "IN"
        },
        "telephone": "+91-9371304510",
        "url": "https://moryacab.com/pune-to-panchgani-taxi-fare",
        "logo": "https://moryacab.com/img/logo.jpg",
        "image": [
          "https://moryacab.com/img/pune-to-panchgani-cab.jpg",
          "https://moryacab.com/img/panchgani-taxi.jpg"
        ],
        "priceRange": "₹1500 - ₹3000",
        "offers": {
          "@type": "Offer",
          "url": "https://moryacab.com/pune-to-panchgani-taxi-fare",
          "priceCurrency": "INR",
          "price": 2000,
          "priceValidUntil": "2025-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": 4.7,
          "reviewCount": 120
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Nikhil Mehta"
            },
            "datePublished": "2024-11-20",
            "reviewBody": "I had a great experience with Morya Cabs. The fare was reasonable, the driver was courteous, and the car was clean and comfortable. The journey from Pune to Panchgani was smooth, and I highly recommend this service."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Rita Sharma"
            },
            "datePublished": "2024-10-12",
            "reviewBody": "The Pune to Panchgani taxi service was amazing. Affordable fares, and the driver was knowledgeable about the best spots to visit in Panchgani. I will definitely use Morya Cabs again."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune to Panchgani Taxi Service",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 18.7669,
            "longitude": 73.9746
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://moryacab.com/pune-to-panchgani-taxi-fare"
        },
        "keywords": "Pune to Panchgani Cab Fare, Pune to Panchgani Taxi Rates, Pune to Panchgani Cab Charges, Pune to Panchgani Taxi Fare to Parsi Point, Pune to Panchgani Cab Pricing, Pune to Panchgani Taxi Fare Katas Point, Pune to Panchgani Cab to Sydney Point, Pune to Panchgani Taxi Fare List, Pune to Panchgani Cab Cost, Pune to Panchgani Cab Fare, Pune Airport to Panchgani Taxi Fare, Pune to Panchgani Distance by Taxi Fare, Pune to Panchgani Taxi Fare, Pune to Panchgani Cab, Pune Airport to Panchgani Taxi Fare, Pune to Panchgani Cab Fare, Pune to Panchgani Distance by Taxi Fare, Pune to Panchgani Ertiga Cab, Pune to Panchgani Taxi, Pune to Panchgani Taxi Distance"
      };
      

    return (
        <div>
            <UsePageTracking/>
<Helmet>
  <title>Pune to Panchgani Cab Fare | Affordable Taxi Service | Call: +91 9371304510</title>
  <meta
    name="description"
    content="Find affordable and reliable taxi fares for your Pune to Panchgani journey. We offer taxi services to top spots like Parsi Point, Katas Point, and Sydney Point at competitive rates."
  />
  <meta
    name="keywords"
    content="Pune to Panchgani Cab Fare, Pune to Panchgani Taxi Rates, Pune to Panchgani Cab Charges, Pune to Panchgani Taxi Fare to Parsi Point, Pune to Panchgani Cab Pricing, Pune to Panchgani Taxi Fare Katas Point, Pune to Panchgani Cab to Sydney Point, Pune to Panchgani Taxi Fare List, Pune to Panchgani Cab Cost, Pune to Panchgani Cab Fare, Pune Airport to Panchgani Taxi Fare, Pune to Panchgani Distance by Taxi Fare, Pune to Panchgani Taxi Fare, Pune to Panchgani Cab, Pune Airport to Panchgani Taxi Fare, Pune to Panchgani Cab Fare, Pune to Panchgani Distance by Taxi Fare, Pune to Panchgani Ertiga Cab, Pune to Panchgani Taxi, Pune to Panchgani Taxi Distance"
  />
  <meta property="og:title" content="Pune to Panchgani Cab Fare | Morya Cabs" />
  <meta
    property="og:description"
    content="Affordable taxi fares for your Pune to Panchgani trip. We offer pricing for visits to Parsi Point, Katas Point, Sydney Point, and more. Book now for a comfortable ride!"
  />
  <meta property="og:url" content="https://moryacab.com/pune-to-panchgani-taxi-fare" />
  <meta property="og:type" content="website" />
  <meta property="og:image" content="https://moryacab.com/img/pune-to-panchgani-cab.jpg" />
  <script type="application/ld+json">
    {JSON.stringify(jsonLD)}
  </script>
</Helmet>

            <div className="breadcumb-wrapper" style={{ backgroundImage: 'url(/img/bg/breadcumb-bg.jpg)' }}>
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/54.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Morya Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                                            {Images.map((e) => {
    return (
        <div className="box1" key={e.text}>
            <a
                href={e.link} // Use the separate link for each item
                className="d-flex justify-content-around align-items-center"
            >
                <div className="b1">
                    <img src={e.place} alt={e.text} />
                </div>
                <div className="b2">
                    <a href={e.link} className="px-3 colorr">{e.text}</a>
                </div>
            </a>
        </div>
    );
})}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #0AB4A9',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#0AB4A9' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 9371304510" className="d-block  text-white">+91 9371304510</a>
                                                <a href="tel:+91 8379975860" className="d-block  text-white">+91 8379975860</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@moryacab.com" className=" text-white d-block">
                                                    booking@moryacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Morya Cab<br />
                                                    Gat no. 763 Jai Ganesh Niwas Flat no. 1 Lokhande Wasti Chimbali Pune, Maharashtra 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Punetopanchganicabfare;